export default {
    id: "84c36083-87ef-49cd-a20a-2158a39784d2",
    icon: "mdi-image",
    name: "image",
    title: "Image",
    description: "A block image"
}